import React from "react";
import "./HrBusinessSolutions.css";

const HrBusinessSolutions = () => {
  return (
    <section className="hr-section">
      <div className="hr-container">
        <div className="hr-header">
          <h4 className="hr-subtitle">Connecting Talent with Opportunity</h4>
          <h2 className="hr-title">HR Solutions & Recruitment Partnerships</h2>
          <p className="hr-description">
            We’re connected with <strong>10,000+ HRs</strong> and{" "}
            <strong>100+ companies globally</strong> — helping businesses find
            the right talent faster. From fresher hiring to corporate
            collaborations, MBR Network’s acts as a reliable partner in all your
            hiring and business expansion needs.
          </p>
        </div>

        <div className="hr-grid">
          <div className="hr-card">
            <div className="hr-icon">🤝</div>
            <h3>Corporate Hiring & Internship Programs</h3>
            <p>
              Partnering with companies to streamline fresher hiring and build
              future-ready teams through internship pipelines.
            </p>
          </div>

          <div className="hr-card">
            <div className="hr-icon">🌎</div>
            <h3>Global HR Network</h3>
            <p>
              Connected with HRs and organizations across diverse industries,
              giving our learners and partners global reach.
            </p>
          </div>

          <div className="hr-card">
            <div className="hr-icon">🧩</div>
            <h3>End-to-End Recruitment Assistance</h3>
            <p>
              From screening and onboarding to team scaling — we ensure
              efficiency and long-term success in every partnership.
            </p>
          </div>
        </div>

        <div className="hr-testimonial">
          <p className="testimonial-text">
            “MBR Network’s has become our go-to partner for hiring and
            mentorship collaborations — they understand both business and
            talent.”
          </p>
          <span className="testimonial-author">
            — HR Manager, Global IT Firm
          </span>
        </div>
      </div>
    </section>
  );
};

export default HrBusinessSolutions;
